import React, { useState } from "react";
//@ts-ignore
import { LanguageContext } from "../../../../context/LanguageContext.jsx";
//@ts-ignore
import { dataList } from "../../AdmMain.jsx";
import Page from "../../../Atomic/template/PageTable";
import SubNavi from "../../../Atomic/molecules/SubNavi";
import { useNavigate } from "react-router-dom";
//@ts-ignore
import TableAtom from "../../../Atomic/organism/AtomTable";

export default function InfoTable() {
  //@ts-ignore
  const { language } = React.useContext(LanguageContext);
  const navi = useNavigate();
  const [data, setData] = useState<any>([
    {
      auth: '위치정보조회',
      admin_auth: true,
      user_auth: true,
    },
    {
      auth: '확인자료조회',
      admin_auth: true,
      user_auth: true,
    },
    {
      auth: '개인정보조회',
      admin_auth: true,
      user_auth: true,
    },
    {
      auth: '위치정보파기',
      admin_auth: true,
      user_auth: false,
    },
    {
      auth: '확인자료파기',
      admin_auth: true,
      user_auth: false,
    },
  ]);
  const [subNavi, setSubNavi] = useState<any>([
    {
      path: "/Adm/mng-access",
      labelKR: "접근권한 정보",
      labelEN: "Auth of Acess Info.",
    },
    {
      path: "/Adm/access-log",
      labelKR: "관리자 접근권한",
      labelEN: "Access Auth of Admin",
    },
  ]);

  function translate(kr: string, en: string) {
    return language === "KOR" ? kr : en;
  }

  const columns: any = [
    {
      header: translate("권한", "Auth"),
      name: "auth",
      align: "center",
    },
    {
      header: translate("위치정보관리 책임자", "Admin"),
      name: "admin_auth",
      align: "center",
      formatter: (e: any) => e?.value ? 'O' : `<span style="color: red">X</span>`
    },
    {
      header: translate("위치정보 취급자", "User"),
      name: "user_auth",
      align: "center",
      formatter: (e: any) => e?.value ? 'O' : `<span style="color: red">X</span>`
    }
  ];

  return (
    <>
      <Page
        language={language}
        dataList={dataList}
        title={`${language === "KOR" ? "접근권한 정보" : "Auth of Acess Info."}`}
        menu="/Adm/mng-access"
      >
        <SubNavi
          subDataList={subNavi}
          language={language}
          navi={navi}
          classPath="/Adm/mng-access"
        />
        <TableAtom data={data} columns={columns} />
      </Page>
    </>
  );
}
